import { useEffect } from "react";

function getBodyClasses() {
  const ua = navigator.userAgent;
  const classes = [];

  // Browser
  if (/Edg\//.test(ua)) classes.push("browser-edge");
  else if (/OPR\//.test(ua)) classes.push("browser-opera");
  else if (/Chrome/.test(ua)) classes.push("browser-chrome");
  else if (/Firefox/.test(ua)) classes.push("browser-firefox");
  else if (/Safari/.test(ua)) classes.push("browser-safari");
  else classes.push("browser-unknown");

  // OS / device
  if (/iPhone|iPad|iPod/.test(ua)) classes.push("os-ios");
  else if (/Android/.test(ua)) classes.push("os-android");
  else if (/Windows NT/.test(ua)) classes.push("os-windows");
  else if (/Mac OS X/.test(ua)) classes.push("os-macos");
  else if (/Linux/.test(ua)) classes.push("os-linux");
  else classes.push("os-unknown");

  // Device type
  if (/Mobi|Android|iPhone/.test(ua)) classes.push("device-mobile");
  else if (/iPad|Tablet/.test(ua)) classes.push("device-tablet");
  else classes.push("device-desktop");

  // Touch support
  if (navigator.maxTouchPoints > 0) classes.push("touch");
  else classes.push("no-touch");

  return classes;
}

export function useBodyClasses() {
  useEffect(() => {
    const classes = getBodyClasses();
    document.body.classList.add(...classes);
    return () => document.body.classList.remove(...classes);
  }, []);
}
